import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Capture the prerendered SEO body before React replaces #root's innerHTML.
// ProductDetail (and friends) can fall back to this HTML when their client-
// side API request fails — preventing transient Googlebot/network errors from
// turning a perfectly indexable prerendered page into a soft-404.
(() => {
    try {
        const rootEl = document.getElementById("root");
        const seo = rootEl && rootEl.querySelector('.seo-prerender[data-prerender="1"]');
        if (seo) {
            window.__OFT_PRERENDER_HTML__ = seo.outerHTML;
        }
    } catch (_) {
        // ignore — fallback is a nice-to-have, not critical
    }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
